import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import { FamilyNewsletterOptionsEnum } from "@/consts/newsletter";
import { familyNewsletterOptions, NewsletterTypes } from "@/consts/newsletter";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "NewsletterSettings",
  components: {
    ValidationObserver,
    ValidationProvider,
    ConfirmDlg
  },
  data() {
    return {
      editMode: false,
      loading: false,
      period: `${moment().add(-7, 'days').format('D')}-${moment().add(-1, 'days').format('D')} ${moment().format('MMM, YYYY')}`,
      familyNewsletterOptions: this.$store.state.facilityModule.selectedFacility.familyNewsletterOptions || familyNewsletterOptions,
      familyNewsletterSettings: null,
      familyNewsletterOptionsEnum: FamilyNewsletterOptionsEnum,
      logoColor: this.$store.state.facilityModule.selectedFacility.logoColor || '#FFFFFF',
      intro: this.$store.state.facilityModule.selectedFacility.familyNewsletterIntro || '',
      colorMenu: false,
    }
  },
  created() {
    this.familyNewsletterSettings = {
      conciergeRequestEventsEnabled: this.familyNewsletterOptions.find(x => x.name == FamilyNewsletterOptionsEnum.ConciergeEventsAttended).status === true,
      lifestyleProgramsEventsEnabled: this.familyNewsletterOptions.find(x => x.name == FamilyNewsletterOptionsEnum.LifestyleEventsAttended).status === true,
      visitEventsEnabled: this.familyNewsletterOptions.find(x => x.name == FamilyNewsletterOptionsEnum.VisitsAttended).status === true,
      callsEventsEnabled: this.familyNewsletterOptions.find(x => x.name == FamilyNewsletterOptionsEnum.VideoCalls).status === true,
      friendsAddedEnabled: this.familyNewsletterOptions.find(x => x.name == FamilyNewsletterOptionsEnum.FriendsAdded).status === true,
      newServicesBookedEnabled: this.familyNewsletterOptions.find(x => x.name == FamilyNewsletterOptionsEnum.NewServicesBooked).status === true,

      includeAttendedEventsGalleryEnabled: this.familyNewsletterOptions.find(x => x.name == FamilyNewsletterOptionsEnum.IncludeAttendedEventsGallery).status === true,
      includeAttendedEventsListEnabled: this.familyNewsletterOptions.find(x => x.name == FamilyNewsletterOptionsEnum.IncludeAttendedEventsList).status === true
    }
  },
  computed: {
    currentFacility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    currentVendors() {
      return this.$store.state.additionalServicesModule.currentVendors;
    },
    familyNewsletterReportingOptions() {
      return this.familyNewsletterOptions.filter(x => x.type == NewsletterTypes.Reporting)
    },
    familyNewsletterEventsOptions() {
      return this.familyNewsletterOptions.filter(x => x.type == NewsletterTypes.Events)
    },
    noImageUrl(){
      return `https://${this.currentFacility.baseUrl}/img/no-image.eb7da0b9.jpg`
    },
    currentDateFormatted(){
     return moment().format(this.currentFacility.dateFormat + ', ' + this.currentFacility.timeFormat)
    },
    familyHubAppName() {
     return this.currentFacility.familyHubAppName
    },
    linkToFamilyHubForAndroid(){
     return this.currentFacility.linkToFamilyHubForAndroid
    },
    linkToFamilyHubForIos(){
      return this.currentFacility.linkToFamilyHubForIos
    },
    contrastColorOfLogo(){
      return this.getContrast50(this.logoColor)
    },
    swatchStyle() {
      return {
        backgroundColor: this.logoColor,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: '100%',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    isSomeFamilyNewsletterOptionsEnabled(){
      return Object.values(this.familyNewsletterSettings).some(x=>x === true)
    },
    todayDateFormatted(){
      return moment(new Date()).format(this.currentFacility.dateFormat + ', ' + this.currentFacility.timeFormat)
    },
  },
  methods: {
    //on firebase functions side exist the same function: _getContrast50(), during update please update both of them
     getContrast50(hexcolor: string) {
      const rgb = parseInt(hexcolor.slice(1), 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = rgb & 0xff;
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
      return luminance > 0.5 ? 'black' : 'white';
    },
    async updateNewsletterSettings() {
      if (!this.editMode) {
        this.editMode = true
        return
      }

      this.loading = true

      const familyNewsletterOptions = this.familyNewsletterOptions.map(x=>{
        if(x.name == FamilyNewsletterOptionsEnum.ConciergeEventsAttended) x.status = this.familyNewsletterSettings.conciergeRequestEventsEnabled
        if(x.name == FamilyNewsletterOptionsEnum.LifestyleEventsAttended) x.status = this.familyNewsletterSettings.lifestyleProgramsEventsEnabled
        if(x.name == FamilyNewsletterOptionsEnum.VisitsAttended) x.status = this.familyNewsletterSettings.visitEventsEnabled
        if(x.name == FamilyNewsletterOptionsEnum.VideoCalls) x.status = this.familyNewsletterSettings.callsEventsEnabled
        if(x.name == FamilyNewsletterOptionsEnum.FriendsAdded) x.status = this.familyNewsletterSettings.friendsAddedEnabled
        if(x.name == FamilyNewsletterOptionsEnum.NewServicesBooked) x.status = this.familyNewsletterSettings.newServicesBookedEnabled
        if(x.name == FamilyNewsletterOptionsEnum.IncludeAttendedEventsGallery) x.status = this.familyNewsletterSettings.includeAttendedEventsGalleryEnabled
        if(x.name == FamilyNewsletterOptionsEnum.IncludeAttendedEventsList) x.status = this.familyNewsletterSettings.includeAttendedEventsListEnabled
        return x
      })

      await this.$store.dispatch("updateFacility", {
        id: this.currentFacility.id,
        logoColor: this.logoColor,
        familyNewsletterIntro:  this.intro,
        familyNewsletterOptions: familyNewsletterOptions
      });

      this.loading = false
      this.editMode = false
      this.$toast.open({ message: this.$i18n.messages[this.$i18n.locale]['NewsletterSettings.SuccessfullyUpdated'], type: "success" });
    },

    onChangeIncludeAttendedEventsList(e){
      if(!e){
        this.familyNewsletterSettings.includeAttendedEventsGalleryEnabled = false
      }
    },

    updateBackgroundColor(event) {
      this.logoColor = event.target.value;
    }
  },
 
}